// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"c3e7ec26","570":"4021bca8"}[chunkId] + ".chunk.css";
};